import Vue from 'vue'
import Vuex from 'vuex'
import fundattio from './modules/fundattio'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
		fundattio
  },
  strict: debug,
  //plugins: debug ? [createLogger()] : []
})